<template>
  <div class="user-feedback">
    <div
      v-if="!hasRated && !newFeedbackSubmitted"
      class="user-feedback__content"
    >
      <h6 class="user-feedback__tagline">
        <span v-if="isComplete">Great Job!</span>
        <span v-else>Keep Going!</span>
      </h6>
      <p class="user-feedback__info">
        <span v-if="isComplete"
          >You made it to the end of the course and if you feel like you
          understand the content, complete this course and celebrate.</span
        >
        <span v-else
          >You still have some work to do. Once you've progressed all the way
          through you can celebrate here.</span
        >
      </p>
      <div class="user-feedback__btn-wrapper">
        <button
          @click="toggleModal()"
          class="btn btn__large"
          :class="!isComplete ? 'user-feedback__disabled' : ''"
        >
          Complete Course
          <span class="material-icons btn__large-icon">check</span>
        </button>
      </div>
    </div>
    <div v-else class="user-feedback__content">
      <h5 class="user-feedback__complete">You have completed this course.</h5>
    </div>
    <transition name="fade" mode="out-in">
      <feedback-form
        v-if="showModal"
        @closeModal="toggleModal()"
        @feedbackSubmitted="newFeedbackSubmitted = true"
        :userId="userId"
        :courseId="courseId"
      ></feedback-form>
    </transition>
  </div>
</template>

<script>
import FeedbackForm from './FeedbackForm.vue'

export default {
  name: 'UserCourseFeedback',
  props: {
    userId: {
      type: String,
      required: true,
    },
    courseId: {
      type: String,
      required: true,
    },
    hasRated: {
      type: Boolean,
      required: true,
    },
    isComplete: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      newFeedbackSubmitted: false,
    }
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal
    },
  },
  components: {
    FeedbackForm,
  },
}
</script>

<style lang="scss" scoped>
.user-feedback {
  display: flex;
  justify-content: center;
  &__content {
    color: var(--white);
    background-color: var(--light-gray);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 30px;
    max-width: 500px;
    @include tablet {
      max-width: 100%;
      padding: 30px 30px 30px 0;
    }
  }
  &__tagline {
    font-size: 2rem;
    border-left: none;
    margin: 0 0 20px 0;
    @include tablet {
      padding: 20px;
    }
    @include desktop {
      border-left: solid 5px var(--orange);
      margin: 0 auto;
    }
  }
  &__info {
    font-size: 1rem;
    color: var(--gray);
    padding: 0;
    margin: 0 0 50px 0;
    @include tablet {
      padding: 0 20px 0 0;
    }
    @include desktop {
      margin: 0 auto;
    }
  }
  &__btn-wrapper {
    min-width: 250px;
  }
  .btn__large {
    min-width: 250px;
  }
  .btn__large-icon {
    color: var(--green);
  }
  &__disabled {
    pointer-events: none;
    opacity: 0.3;
  }
  &__complete {
    width: 500px;
    text-align: center;
    color: var(--orange);
  }
}
</style>
